import { useState } from 'react';
import { WbIcon, WbTooltip } from '@workbench/react';
import { useTranslation } from 'react-i18next';
import './CopyButton.scss';

function CopyButton({ data }) {
	const { t } = useTranslation();
	const [copied, setCopied] = useState(false);

	const copy = async () => {
		try {
			await navigator.clipboard.writeText(JSON.stringify(data, null, 2));
			setCopied(true);
			setTimeout(() => setCopied(false), 2000);
		} catch (error) {
			console.error('Copy to clipboard failed', error);
		}
	};

	const label = copied
		? t('vimdt.specificationsTab.copiedData')
		: t('vimdt.specificationsTab.copyTheData');

	return (
		<WbTooltip position="top">
			<button type="button" className="vimdt-copy-button" onClick={copy} aria-label={label}>
				<WbIcon name={copied ? 'bds/checkmark/24' : 'bds/copy/24'} />
			</button>
			<span slot="content">{label}</span>
		</WbTooltip>
	);
}

export default CopyButton;
